export default __webpack_public_path__ + "static/media/TTO.48b9b395.svg";